import Swiper from "swiper";
import { Navigation, Autoplay } from "swiper/modules";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import "swiper/css";
import "swiper/css/navigation";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
  const sliders = document.querySelectorAll(".projectSwiper");
  sliders.forEach((slider) => {
    new Swiper(slider, {
      modules: [Navigation, Autoplay],
      loop: true,
      speed: 800,
      spaceBetween: 30,
      slidesPerView: 1,
      navigation: {
        nextEl: slider.querySelector(".swiper-button-next"),
        prevEl: slider.querySelector(".swiper-button-prev"),
      },
     /*  autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      }, */
      on: {
        init: function () {
          // Animate first slide text on load
          animateSlideText(this.slides[this.activeIndex]);
        },
        slideChangeTransitionStart: function () {
          // Fade out old slide content
          const prevSlide = this.slides[this.previousIndex];
          gsap.to(
            prevSlide.querySelectorAll(".title, .tags, .description, .btn"),
            {
              opacity: 0,
              y: 20,
              duration: 0.5,
              ease: "power2.out",
            }
          );
        },
        slideChangeTransitionEnd: function () {
          // Animate new active slide text
          animateSlideText(this.slides[this.activeIndex]);
        },
      },
    });

    // Function to animate text on each active slide
    function animateSlideText(activeSlide) {
      const elements = activeSlide.querySelectorAll(
        ".title, .tags, .description, .btn"
      );

      if (!elements.length) return;

      gsap.fromTo(
        elements,
        { opacity: 0, y: 30, filter: "blur(5px)" },
        {
          opacity: 1,
          y: 0,
          filter: "blur(0px)",
          duration: 1.2,
          ease: "power3.out",
          stagger: 0.15, // text items appear one after another
        }
      );
    }
  });

  const moreWorkbtn = document.querySelector(".more-works-btn");

  gsap.fromTo(
    moreWorkbtn,
    {
      opacity: 0,
      y: 50,
      filter: "blur(5px)",
    },
    {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      duration: 1.2,
      ease: "power3.out",
      scrollTrigger: {
        trigger: moreWorkbtn,
        start: "top 80%", // starts when the heading is near the viewport
        toggleActions: "play none none reverse", // animates back when scrolling up
      },
    }
  );
});
